import { render, staticRenderFns } from "./editContact.vue?vue&type=template&id=1bfe3460"
import script from "./editContact.vue?vue&type=script&lang=js"
export * from "./editContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports